module.exports = __webpack_public_path__ + "src/assets/games/24/231.jpg";